import * as React from "react";
import { connect } from "react-redux";
import * as selectors from "../selectors";
import { RootState } from "src/ipm-shared/store/model/reducers";

type IHasErrorsProps = {
  className?: string;
  form: string;
  children: (props: boolean) => React.ReactNode;
  withServerError?: boolean;
};
const mapStateToProps = (
  state: RootState,
  props: IHasErrorsProps
): {
  hasError: boolean;
} => ({
  hasError: selectors.hasError(state, props.form, props.withServerError)
});

type IProps = ReturnType<typeof mapStateToProps> & IHasErrorsProps;

/**
 * This is one of common controls in the entire app.
 * Use this when you want to show Form errors.
 */
class HasErrors extends React.Component<IProps, any> {
  public render() {
    return this.props.children(this.props.hasError);
  }
}

export default connect(mapStateToProps)(HasErrors);
